import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;
const BASE_URL_V2 = process.env.REACT_APP_API_URL_V2;

const axiosInstance = axios.create({
	baseURL: BASE_URL,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
	},
});

export const axiosInstanceV2 = axios.create({
	baseURL: BASE_URL_V2,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json',
	},
});

const responseInterceptor = (instance) => {
	instance.interceptors.response.use(
		(response) => response,
		(error) => {
			if (error.response && error.response.status === 401) {
				localStorage.clear();
				window.location.href = '/';
			}
			return Promise.reject(error);
		},
	);
};

responseInterceptor(axiosInstance);
responseInterceptor(axiosInstanceV2);

export default axiosInstance;
